exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-component{height:359px;background:url(" + require("../images/header-bg.jpg") + ") no-repeat 0 0}ul{list-style:none}#header .logo{position:absolute;left:14px;top:88px}#header .slogan{position:absolute;left:39px;top:227px}.list{position:absolute;right:177px;top:5px}.list li{float:left;background:url(" + require("../images/divider1.gif") + ") no-repeat 100% 0;padding-right:20px;margin-right:20px}.list li.last{background:none;padding-right:0;margin-right:0}.site-nav{position:absolute;left:12px;top:25px}.site-nav li{float:left;font-family:Arial,Helvetica,sans-serif;font-size:.92em;text-transform:uppercase;background:url(" + require("../images/divider2.gif") + ") repeat-y 100% 0}.site-nav li a{text-decoration:none;color:#bfbfbf;display:block;padding:13px 12px 2px;font-size:.75em}.site-nav li a:hover{text-decoration:underline}.site-nav li.last{background:none}.logo{position:absolute;left:14px;top:88px}.linkOld{text-decoration:underline;color:grey;display:block;padding:13px 28px 2px;font-size:.75em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/Header.css
// module id = 142
// module chunks = 0